import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const StyledPrimaryButton = styled.button`
    width: 150px;
    height: 35px;
    background-color: ${(props) => props.theme.color.primaryblue};
    color: white;
    font-size: 12px;
    font-weight: 600;
    border: none;
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    cursor: pointer;
    padding-bottom: 4px;
    user-select: none;
    border-radius: 2px;

    &:hover:enabled {
        background-color: ${(props) => props.theme.color.primaryhover};
    }
    :active:enabled {
        border:1px solid ${(props) => props.theme.color.primaryhover};
        box-shadow: 0 0 3px ${(props) => props.theme.color.primaryhover};
    }
    :disabled {
        color: ${(props) => props.theme.color.gray};
        background-color: ${(props) => props.theme.color.disabledgray}
    }
`;

function PrimaryButton(props) {

    const {caption, isLoading, ...restProps} = props;

    return (
        <StyledPrimaryButton {...restProps}>
            {isLoading && <FontAwesomeIcon icon={faSpinner} className='spinner' spin style={{marginRight: 5}}></FontAwesomeIcon>}
            {caption}
        </StyledPrimaryButton>
    )
}

export default PrimaryButton;